<template>
  <TextFieldInput
    ref="txtBarcode"
    :label="$t('ELE0548')"
    v-model="model"
    prependIcon="mdi-barcode"
    isQRField
    :required="required"
    @blur="scanned"
    maxLength="200"
  />
</template>

<script>
import { SystemParameterKey } from '@/enum'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'

export default {
  name: 'InspLotSerialNoInput',

  mixins: [APIUtils, Message, Loading],
  components: { TextFieldInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    disableFocus: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formatSerialNo: '',
      lastScannedValue: '',
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },

    serialRegex() {
      if (!this.formatSerialNo) return null
      try {
        return new RegExp(this.formatSerialNo)
      } catch {
        return null
      }
    },
  },

  //シリアルNoフォーマットをシステムパラメーターからセットする
  async mounted() {
    this.startLoading()
    try {
      const param = await API.get(`/master/systemParameter/${SystemParameterKey.FORMAT_SERIAL_NO}`)
      this.formatSerialNo = param.value
    } catch (error) {
      this.formatSerialNo = ''
      if (error.response.status != 404) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0348') })))
      }
    } finally {
      this.focus()
      this.stopLoading()
    }
  },

  methods: {
    async scanned() {
      // 空文字列・前回と同じ値を読ませない処理
      if (!this.model) {
        return
      }
      if (this.model == this.lastScannedValue) {
        this.focus()
        return
      }
      this.lastScannedValue = this.model

      if (!this.isValidSerial(this.model)) {
        this.setErrorMessage(this.$t('MSG0190'))
        this.focus()
        return
      }
      this.$emit('scanned', this.model)
      this.focus()
    },
    isValidSerial(value) {
      if (!this.serialRegex) return true
      if (value == null) return false
      return this.serialRegex.test(String(value))
    },
    focus() {
      // ダイアログ表示中はフォーカスの奪い合いによる無限ループを防ぐため、focusしない
      if (!this.disableFocus) {
        this.$refs.txtBarcode.focus()
      }
    },
  },
}
</script>
